import React from 'react';

import { Page, UItils } from '@nearst/ui';
import DatePicker from '@components/DatePicker';
import FreeLocalListings from '../SWIS/FreeLocalListings';
import UpgradeRequiredBanner from '@components/UpgradeRequiredBanner';
import InsightTeaserOverlay from '../components/InsightTeaserOverlay';
import { useShop } from '@services/ShopProvider';

import styles from './LocalListingsChain.module.scss';
import ProductPageLinkingAnalytics from '../SWIS/ProductPageLinkingAnalytics';

const LocalListingsChain = () => {
	const { data: shops } = useShop();
	const onFreemium = shops.every((shop) => shop.plan === 'freemium');

	return (
		<>
			<Page.Header>
				<h1>Local Listings</h1>
				<p>Understand the trends in your Google organic listings performance and compare metrics across all locations.</p>
				<DatePicker showComparison showInterval />
			</Page.Header>
			<Page.Section>
				{onFreemium ? (
					<UpgradeRequiredBanner>
						Upgrade your plan to discover how your products are performing across your Local Listings.
					</UpgradeRequiredBanner>
				) : null}
				<div className={styles.fullWidthCard}>
					{onFreemium ? (
						<InsightTeaserOverlay>
							<div className={UItils.classnames(styles.fullWidthCard, styles.teaser)}>
								<FreeLocalListings teaser subtitle="All locations" />
							</div>
						</InsightTeaserOverlay>
					) : (
						<>
							<FreeLocalListings subtitle="All locations" />
							<ProductPageLinkingAnalytics shops={shops} />
						</>
					)}
				</div>
			</Page.Section>
		</>
	);
};

export default LocalListingsChain;
